export default __webpack_public_path__ + "img/dRibSNoi.22b36eec.svg";